import React from 'react';
import MicrosoftExcelSelect, {
  MicrosoftExcelSelectProps,
} from './MicrosoftExcelSelect';

const PushMicrosoftExcelData: React.FC<MicrosoftExcelSelectProps> = props => (
  <MicrosoftExcelSelect {...props} showNewSheetOption />
);

export default PushMicrosoftExcelData;
